import { Operation } from '.'
import { ArrayFilterFn } from '../internal'
import { _filter } from '../filter'

/**
 * Simple array filter (wraps native Array#filter)
 */
export function filter<T, R extends T>(filterFn: ArrayFilterFn<T, R>): Operation<T, R>;

/**
 * Object pick filter - pick the given key from each object in the given array and filter based on that being === true
 */
export function filter<T, K extends keyof T>(filterFn: K): Operation<T>;

/**
 * Object matcher filter - filter to objects in the given array where each of the corresponding properties is
 * strictly equal (===) to the supplied matcher.
 */
export function filter<T>(objectMatcher: Partial<T>): Operation<T>;

export function filter(filterFn: any): any {
	return (collection: any[]) => {
		return _filter(collection, filterFn)
	}
}